import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PbxOverview from 'flow/route-components/PbxOverview';
import PbxQueueMember from 'flow/route-components/PbxQueueMember';
import PbxProfiles from 'flow/route-components/PbxProfiles';
import { routes } from 'flow/types/routes';

const PbxOverviewRoutes = () => (
    <Switch>
        <Route
            path={routes['pbx.overview.queueKey.members']}
            component={PbxQueueMember}
        />
        <Route
            path={routes['pbx.overview.entityKey.pbxProfiles']}
            component={PbxProfiles}
        />
        <Route path={routes['pbx.overview']} component={PbxOverview} />
    </Switch>
);

export default PbxOverviewRoutes;
